export interface ProviderPanelData {
  providersRespondedCount?: number;
  providersAttemptedCount?: number;
  dataCompleteness?: number;
  criticalProvidersHealthy?: boolean;
  criticalProvidersUsed?: boolean;
}

export function ProviderPanel({ data }: { data: ProviderPanelData | null | undefined }) {
  const d = data ?? null;

  if (!d) return null;

  const responded = d.providersRespondedCount ?? 0;
  const total = d.providersAttemptedCount ?? responded;
  const hasHealthField = typeof d.criticalProvidersHealthy === 'boolean';
  const hasUsedField = typeof d.criticalProvidersUsed === 'boolean';
  const pct = total > 0 ? (responded / total) * 100 : 0;

  const quality = pct >= 70 ? 'FULL' : pct >= 40 ? 'PARTIAL' : 'LIMITED';
  const qualityColor = quality === 'FULL' ? '#22c55e' : quality === 'PARTIAL' ? '#f39c12' : '#ef4444';

  return (
    <div className="dash-card ws-forensic-section">
      <h3 className="ws-forensic-title" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        Data Sources
      </h3>

      <div className="intel-grid intel-grid-3">
        <div className="intel-metric-card card">
          <div className="intel-metric">
            <span className="intel-metric-label">Data Sources Checked</span>
            <span className="intel-metric-value">{total}</span>
          </div>
        </div>
        <div className="intel-metric-card card">
          <div className="intel-metric">
            <span className="intel-metric-label">Data Sources Responded</span>
            <span className="intel-metric-value" style={{ color: qualityColor }}>{responded}</span>
          </div>
        </div>
        <div className="intel-metric-card card">
          <div className="intel-metric">
            <span className="intel-metric-label">Data Quality</span>
            <span className="intel-metric-value" style={{ color: qualityColor }}>{quality}</span>
          </div>
        </div>
      </div>

      <div style={{ marginTop: '0.5rem', height: 6, borderRadius: 3, background: 'rgba(255,255,255,0.08)', overflow: 'hidden' }}>
        <div style={{
          width: `${pct}%`,
          height: '100%',
          borderRadius: 3,
          background: qualityColor,
          transition: 'width 0.5s ease',
        }} />
      </div>

      {(hasHealthField || hasUsedField) && (
        <div style={{ display: 'flex', gap: '1rem', marginTop: '0.5rem', flexWrap: 'wrap' }}>
          {hasHealthField && (
            <span style={{
              fontSize: '0.75rem',
              padding: '0.2rem 0.6rem',
              borderRadius: '4px',
              background: d.criticalProvidersHealthy ? 'rgba(34,197,94,0.12)' : 'rgba(239,68,68,0.12)',
              color: d.criticalProvidersHealthy ? '#22c55e' : '#ef4444',
              border: `1px solid ${d.criticalProvidersHealthy ? 'rgba(34,197,94,0.3)' : 'rgba(239,68,68,0.3)'}`,
            }}>
              Critical Sources Healthy: {d.criticalProvidersHealthy ? 'Yes' : 'No'}
            </span>
          )}
          {hasUsedField && (
            <span style={{
              fontSize: '0.75rem',
              padding: '0.2rem 0.6rem',
              borderRadius: '4px',
              background: d.criticalProvidersUsed ? 'rgba(34,197,94,0.12)' : 'rgba(148,163,184,0.12)',
              color: d.criticalProvidersUsed ? '#22c55e' : '#94a3b8',
              border: `1px solid ${d.criticalProvidersUsed ? 'rgba(34,197,94,0.3)' : 'rgba(148,163,184,0.3)'}`,
            }}>
              Critical Sources Used: {d.criticalProvidersUsed ? 'Yes' : 'No'}
            </span>
          )}
        </div>
      )}

      <div style={{ marginTop: '0.5rem', fontSize: '0.7rem', color: 'var(--text-muted)', textAlign: 'right' }}>
        Last scan: {new Date().toLocaleString()}
      </div>
    </div>
  );
}
